import { useQuery } from '@tanstack/react-query';
import { supabase } from '../services/supabase';

export interface AdminUser {
  id: string;
  username: string;
  is_admin: boolean;
  created_at: string;
}

const fetchUsers = async (): Promise<AdminUser[]> => {
  const { data, error } = await supabase
    .from('profiles')
    .select('id, username, is_admin, created_at');

  if (error) {
    throw new Error(error.message);
  }

  return data as AdminUser[];
};

export const useAdmin = () => {
  const { data: users, isLoading: isLoadingUsers, error: usersError } = useQuery<AdminUser[], Error>({
    queryKey: ['admin_users'],
    queryFn: fetchUsers,
  });

  // In a real app, you'd fetch more admin data here (e.g., stats, logs)
  // For now, we'll just simulate some stats

  const stats = {
    totalUsers: users?.length ?? 0,
    newUsersToday: users?.filter(u => new Date(u.created_at) > new Date(new Date().setDate(new Date().getDate() - 1))).length ?? 0,
    activeUsers: users?.filter(u => (u as any).last_sign_in_at && new Date((u as any).last_sign_in_at) > new Date(new Date().setDate(new Date().getDate() - 7))).length ?? 0,
  };

  return {
    users,
    isLoadingUsers,
    usersError,
    stats,
    isLoading: isLoadingUsers, // Combined loading state
    error: usersError, // Combined error state
  };
};